<template>
  <my-refresh-more v-model="list" :pageSize="10" :getList="getList" :getParams="getParams">
    <div slot="list" class="goods-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="goods-item d-flex flex-row justify-content-between align-items-center"
      >
        <div class="flex-1 d-flex flex-column">
          <div style="font-size: 14px;">{{item.description}}</div>
          <div style="font-size: 14px;" class="timeStr">{{item.createTime}}</div>
        </div>
        <div>{{item.amount}}</div>
      </div>
    </div>
  </my-refresh-more>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      shoppingCardId: ''
    };
  },

  created () {
    let query = this.$route.query
    this.shoppingCardId = query.shoppingCardId
  },
  methods: {
    getParams () {
      return { shoppingCardId: this.shoppingCardId }
    },
    getList (page, size, param) {
      let { shoppingCardId } = param
      let params = {
        page: page,
        size: size,
        shoppingCardId,
      }
      console.log('getList', params)
      return new Promise((resolve, reject) => {
        this.$http.request(this.$http.pathMap.cardLogs, 'get', params).then(res => {
          let data = res.data
          data.list.forEach(item => {
            item.timeStr = this.$uitl.formatTime('YYYY-mm-dd HH:MM', new Date(item.createTime))
          })
          resolve(data)
        })
      })
    }
  },
}
</script>

<style lang="scss" scoped>
/* 分类 */
/* 商品列表 */
.goods-list {
  padding: 0 15px;
  background: #fff;
  .goods-item {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 5px 10px;
    border-bottom: 1px rgba(230, 230, 230, 1) solid;
    .timeStr {
      color: $font-color-light;
      font-size: $uni-font-size-lg;
    }
  }
}
</style>
